import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"

// Drag-reorder for the catalog assembly editor. Each parent's children are their own
// Sortable (unique group name) so reordering stays within one parent — the position
// -only reorder PATCH can't persist a cross-parent move. Every reorder re-renders the
// tree via Turbo Stream.
export default class extends Controller {
  static targets = ["children"]
  static values = { reorderUrl: String, editable: Boolean }

  connect() {
    if (this.editableValue) this.initSortables()
  }

  disconnect() {
    ;(this.sortables || []).forEach((sortable) => sortable.destroy())
  }

  initSortables() {
    this.sortables = this.childrenTargets.map(
      (container, index) =>
        new Sortable(container, {
          draggable: "[data-id]",
          handle: "[data-drag-handle]",
          animation: 150,
          group: { name: `catalog-tree-${index}`, pull: false, put: false },
          onEnd: (event) => this.reorder(event),
        }),
    )
  }

  reorder(event) {
    const container = event.to
    const parentId = container.dataset.parentId || null
    const positions = Array.from(container.children)
      .filter((el) => el.dataset.id)
      .map((el, index) => ({ id: parseInt(el.dataset.id), position: index + 1 }))
    if (positions.length === 0) return

    const token = document.head.querySelector('meta[name="csrf-token"]').getAttribute("content")
    fetch(this.reorderUrlValue, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": token,
        Accept: "text/vnd.turbo-stream.html",
        "Content-type": "application/json",
      },
      body: JSON.stringify({ parent_id: parentId, positions: positions }),
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
  }
}
